export default "__VITE_ASSET__Sc0biEYc__"